declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/home.scss';

import { h, Component } from 'preact';
import Clients from './Clients';
import Productsdemo from './productsdemo';

export default class Home extends Component<any, any> {

    constructor() {
        super();
    }
    
    private showYT (id, e) {
      e.preventDefault();
      this.props.ytCB(id);
    }

    public render (props, state): any {

        return <div id="home">
          <div class="mainWrp">
            <section>
              <h1>Engage with your prospects, customers and employees with our Omnichannel AI Platform</h1>
              <figure class="imgHolder">
                <img alt="Omnichannel by Querlo" src={ STATIC_BASE_URL + 'images/public/omnichannel.png' } />
              </figure>
              <p class="center calltoaction"><a href="#" onClick={ this.showYT.bind(this, 'mGJeupFU1-g') } class="butt huge secondary">watch demo</a> <a href="./register" class="butt huge">Try it free</a></p>
            </section>
          </div>

          <section class="full">
            <h2>Welcome to Querlo Conversational AI Platform</h2>
            <p>
              Querlo provides solutions to drive engagement and improve experience of internal and external stakeholders, facilitating B2B, B2C and B2E transactions across all communication channels and languages.
            </p>
          </section>
            <div class="full grey prods">
              <div class="mainWrp">
                <h2>Increase your revenues with our Virtual Assistants</h2>
                
                <Productsdemo />
              
              </div>
            </div>
          <Clients />
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Home.tsx